// 👉 Redirects
export const redirects = [
  // Root redirect — send authenticated users to home, others to login
  {
    path: '/',
    name: 'index',
    redirect: to => {
      const raw = localStorage.getItem('userData')
      let user = null

      if (raw && raw !== 'undefined') {
        try {
          user = JSON.parse(raw)
        } catch (e) {
          console.warn('Invalid userData in localStorage:', raw)
          user = null
        }
      }

      if (user) {
        return { name: 'home' }
      }

      return { name: 'login', query: to.query }
    },
    meta: { public: true },
  },
]

export const routes = [
  // LOGIN
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/login.vue'),
    meta: { guestOnly: true },
  },
]
